import React from "react"
import ReactDOM from "react-dom/client"
import * as Sentry from "@sentry/react"
import { AwsRumProvider } from "aws-rum-react"
import { BrowserRouter } from "react-router-dom"
import { QueryClient, QueryClientProvider } from "@tanstack/react-query"

import { getConfig } from "@components/Config"
import { initializeSentry, initializeRum } from "@components/AppContext"

import AuthenticatorContext from "./components/AuthenticatorContext"

import App from "./App"

const queryClient = new QueryClient()

const PLATFORM_EMAIL = getConfig("PLATFORM_EMAIL")

const LABEL_ERROR = `Oops, something went wrong. Please try reloading the
page. If the issue persists, contact`

initializeSentry()
const rumClient = initializeRum()

const root = ReactDOM.createRoot(document.getElementById("root"))

root.render(
  <AwsRumProvider client={rumClient}>
    <Sentry.ErrorBoundary fallback={
      <div style={{ margin: "4px 6px", fontSize: 14 }}>
        {LABEL_ERROR} <a href={`mailto:${PLATFORM_EMAIL}`}>{PLATFORM_EMAIL}</a>.
      </div>
    }>
      <BrowserRouter>
        <QueryClientProvider client={queryClient}>
          <AuthenticatorContext>
            <App />
          </AuthenticatorContext>
        </QueryClientProvider>
      </BrowserRouter>
    </Sentry.ErrorBoundary>
  </AwsRumProvider>
)
